import React, { useEffect } from "react";
import * as styles from "./breadcrumtwo.module.scss";
import { Link } from "@reach/router";
import { useLink, useLocalPath } from "../../hooks/index"
import { useValidateBreadcrumb } from "../../hooks/index.ts"
import { GoHomeFill } from "react-icons/go";


type Props = {
    data: { slug: string; title: string }[];
    title: string;
};

const BreadcrumTwo = ({ data, title }: Props) => {
    const { isValid, jsonLd } = useValidateBreadcrumb({ data, title });

    useEffect(() => {
        if (isValid && jsonLd) {
            const script = document.createElement("script");
            script.type = "application/ld+json";
            script.text = JSON.stringify(jsonLd);
            document.head.appendChild(script);

            return () => {
                document.head.removeChild(script);
            };
        }
    }, [isValid, jsonLd]);


    function toSentenceCase(str: string) {
        if (!str || str.length === 0) {
            return "";
        }
        const firstChar = str.charAt(0).toUpperCase();
        const restOfStr = str.slice(1).toLowerCase();

        return firstChar + restOfStr;
    }

    return (
        <div className={ `${styles.strip}`}>
            <div className={` ${styles.wrapper}`}>

                <span className={styles.breadcrumLink}>
                    <a href={`${useLink("/")}`} aria-label="Home" >
                        <GoHomeFill className={styles.homeSvg} />
                    </a>
                    <span>
                        <svg className={styles.arrowSvg} xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                            <path d="M12.6 12.5L8 7.9L9.4 6.5L15.4 12.5L9.4 18.5L8 17.1L12.6 12.5Z" fill="#C7C4D7" />
                        </svg>
                    </span>
                </span>


                {data.map((item: { slug: string; title: string }, id: number) => {
                    if (item.title.toLowerCase() === "home") {
                        return null;
                    }
                    const localizedSlug = useLocalPath(item.slug);

                    return (
                        <span className= {styles.breadcrumLink} key={id}>
                            <a href={`${useLink(item.slug)}`}>{toSentenceCase(item.title)}</a>


                            <span className={styles.arrow}>
                                <svg
                                    className={styles.arrowSvg}
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="25"
                                    viewBox="0 0 24 25"
                                    fill="none"
                                >
                                    <path
                                        d="M12.6 12.5L8 7.9L9.4 6.5L15.4 12.5L9.4 18.5L8 17.1L12.6 12.5Z"
                                        fill="#C7C4D7"
                                    />
                                </svg>
                            </span>
                        </span>
                    )
                })}


                <span className={styles.breadcrumTitle}>
                    {toSentenceCase(title.split(' / ').join(' ').toLowerCase())}
                </span>
            </div>
        </div>
    );
};

export default BreadcrumTwo;